<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";

</script>

<button class="fizz-icon-button" on:click>
  <div data-counter={0}>
    <Icon type="Bell" extraClassNames="fizz-icon-24 fizz-text-brand" id="notification-center" />
  </div>
</button>
